import { get } from '../api.js';
import { setTopbar, lucideIcons, esc } from '../app.js';
import { relTime } from '../utils.js';
import { decryptItemSummary } from '../item-decrypt.js';

const ACTION_ICONS = { create: 'plus-circle', read: 'eye', delete: 'trash-2', grant: 'share-2', auth: 'shield' };

function classifyAction(action) {
  if (action.includes('create') || action.includes('update') || action.includes('claim')) return 'create';
  if (action.includes('read') || action.includes('access') || action.includes('view')) return 'read';
  if (action.includes('delete') || action.includes('revoke')) return 'delete';
  if (action.includes('grant')) return 'grant';
  if (action.includes('auth') || action.includes('login') || action.includes('checkin')) return 'auth';
  return 'auth';
}


export async function renderAuditLog(container) {
  setTopbar('Audit Log', '');

  container.innerHTML = `
    <div style="display:flex;gap:10px;margin-bottom:20px;flex-wrap:wrap">
      <div class="search-bar" style="flex:1;min-width:200px;margin-bottom:0"><i data-lucide="search"></i><input placeholder="Search audit log..." id="audit-search"></div>
      <select class="form-input" style="width:auto;min-width:160px" id="filter-type">
        <option value="">All events</option>
        <option value="user">Auth</option>
        <option value="item">Items</option>
        <option value="grant">Grants</option>
      </select>
    </div>
    <div id="audit-content"><p class="loading">Loading...</p></div>
  `;
  lucideIcons();

  // Build item name map once
  let itemNames = null;
  async function getItemNames() {
    if (itemNames) return itemNames;
    itemNames = new Map();
    try {
      const items = await get('/items');
      for (const item of items) {
        const summary = decryptItemSummary(item);
        if (summary.name !== 'Untitled') {
          itemNames.set(item.id, summary.name);
        }
      }
    } catch {}
    return itemNames;
  }

  const load = async () => {
    const filter = document.getElementById('filter-type').value;
    const qs = filter ? `?resource_type=${filter}&limit=50` : '?limit=50';
    try {
      const [entries, names] = await Promise.all([get(`/audit-log${qs}`), getItemNames()]);
      const content = document.getElementById('audit-content');
      if (!entries.length) {
        content.innerHTML = '<div class="empty">No audit entries</div>';
        return;
      }

      let html = '<div class="timeline">';
      entries.forEach(e => {
        const type = classifyAction(e.action);
        const icon = ACTION_ICONS[type] || 'activity';
        const resourceName = e.resource_id && names.has(e.resource_id) ? names.get(e.resource_id) : null;
        const resourceLabel = resourceName
          ? `<a href="#/items/${e.resource_id}" style="color:inherit;text-decoration:underline">${esc(resourceName)}</a>`
          : `${esc(e.resource_type)}:${e.resource_id ? e.resource_id.slice(0, 8) : '--'}`;
        html += `
          <div class="timeline-entry" data-text="${esc(e.action + ' ' + (e.resource_type || '') + ' ' + (resourceName || ''))}">
            <div class="timeline-dot action-${type}"><i data-lucide="${icon}"></i></div>
            <div class="timeline-content">
              <div class="timeline-header">
                <span class="timeline-action">${esc(e.action)}</span>
                <span class="timeline-time">${relTime(e.created_at)}</span>
              </div>
              <div class="timeline-detail">
                <span>${resourceLabel}</span>
                <span><i data-lucide="monitor" style="width:12px;height:12px"></i> ${esc(e.ip_address || '-')}</span>
              </div>
            </div>
          </div>`;
      });
      html += '</div>';
      content.innerHTML = html;
      lucideIcons();
    } catch (err) {
      document.getElementById('audit-content').innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
    }
  };

  document.getElementById('filter-type').onchange = load;
  document.getElementById('audit-search').oninput = (e) => {
    const q = e.target.value.toLowerCase();
    document.querySelectorAll('.timeline-entry').forEach(el => {
      el.style.display = (el.dataset.text || '').toLowerCase().includes(q) ? '' : 'none';
    });
  };

  load();
}
